import {createAction, props} from '@ngrx/store';
import {ExportCase} from './export-case.type';

/**
 * DatevWizardCaseSelectionActions
 *
 * Actions für die Fallauswahl im DATEV-Wizard.
 */
export class DatevWizardCaseSelectionActions {
  private static readonly prefix = '[Datev Wizard Case Selection]';

  /**
   * Action zum Speichern der gewählten Export-Fall-Auswahl.
   * Triggert automatisch die Navigation zu client-id (via Effect).
   */
  public static selectCase = createAction(
    `${this.prefix} Select Case`,
    props<{
      caseType: ExportCase,
    }>(),
  );

  /**
   * Action zum Navigieren zur client-id Seite.
   * Wird vom selectCase$ Effect dispatcht.
   */
  public static goToClientId = createAction(
    `${this.prefix} Go to client id`,
  );

  /**
   * Action zum Zurücksetzen der Case-Selection.
   * Wird nach dem Löschen einer Konfiguration aufgerufen.
   */
  public static resetCaseSelection = createAction(
    `${this.prefix} Reset case selection`,
  );
}
